var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.type === '3')?_c('push-detail',{attrs:{"activityId":_vm.id}}):(_vm.type === '4')?_c('charge-detail',{attrs:{"activityId":_vm.id}}):(_vm.type === '5')?_c('scan-detail',{attrs:{"activityId":_vm.id}}):(_vm.type === '6')?_c('exchange-detail',{attrs:{"activityId":_vm.id}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }